/*
 * @Author: zxf
 * @Date: 2022-04-02 11:26:48
 * @Description: 指南针接口
 */
const initApiMethods = (ext) => {
  const Ext = ext;

  const Methods = Ext.methods;

  Ext.setDirection = (quaternion) => {
    Methods.setDirection(quaternion);
  };

  Ext.show = () => {
    Methods.show();
  };

  Ext.hide = () => {
    Methods.hide();
  };
};

module.exports = initApiMethods;
